import {
  getGetWorkspaceApiV1QueryKey,
  getGetWorkspaceMembersApiV1QueryKey,
  useGetWorkspaceApiV1Suspense,
  useGetWorkspaceMemberApiV1Suspense,
} from "@/api/__generated__/api.schema";
import { useUser } from "@/hooks/auth/use-user";
import { invariant } from "@/utils/invariant";
import { useParams } from "react-router";

export const useWorkspaceId = () => {
  const { workspaceId } = useParams<{ workspaceId: string }>();

  invariant(workspaceId != null, "Workspace ID is required");

  return workspaceId;
};

export function useWorkspace() {
  const workspaceId = useWorkspaceId();
  const { data } = useGetWorkspaceApiV1Suspense(workspaceId);

  return { data: data.data.item };
}

useWorkspace.queryKey = (workspaceId: string) => getGetWorkspaceApiV1QueryKey(workspaceId);

export function useWorkspaceMemberInfo() {
  const { data: user } = useUser();
  const workspaceId = useWorkspaceId();
  const { data } = useGetWorkspaceMemberApiV1Suspense(workspaceId, user.id);

  return { data: data.data.item };
}

useWorkspaceMemberInfo.queryKey = (workspaceId: string) => getGetWorkspaceMembersApiV1QueryKey(workspaceId);
